import { isSiteOwnerEmail } from "./site-owner";

export function isDealershipAccount(
  user: { accountType?: unknown } | null | undefined,
): boolean {
  if (!user || user.accountType == null) return false;
  return String(user.accountType).toLowerCase() === "dealership";
}

export function isOwnerUser(user: { isOwner?: unknown } | null | undefined): boolean {
  if (!user || user.isOwner == null) return false;
  return Boolean(user.isOwner);
}

/** Admin dashboard + elevated APIs (includes site owner). */
export function isAdminUser(
  user: { role?: unknown; isOwner?: unknown; email?: unknown } | null | undefined,
): boolean {
  if (!user) return false;
  if (isOwnerUser(user)) return true;
  if (user.email != null && isSiteOwnerEmail(String(user.email))) return true;
  if (user.role == null) return false;
  return String(user.role).toLowerCase() === "admin";
}

/** Live boost package picker · dealership sellers + admin/owner. */
export function canAccessBoostFeatures(
  user: { accountType?: unknown; role?: unknown; isOwner?: unknown; email?: unknown } | null | undefined,
): boolean {
  return isDealershipAccount(user) || isAdminUser(user);
}

/** Free listing quota · dealership sellers + admin/owner; not personal bidders. */
export function canUseFreeListingQuota(
  user: { accountType?: unknown; role?: unknown; isOwner?: unknown; email?: unknown } | null | undefined,
): boolean {
  return isDealershipAccount(user) || isAdminUser(user);
}

/** Dealer inquiry CRM (inbox, archive, home cards) · dealership sellers + admin/owner. */
export function canAccessDealerInquiryCrm(
  user: { accountType?: unknown; role?: unknown; isOwner?: unknown; email?: unknown } | null | undefined,
): boolean {
  return isDealershipAccount(user) || isAdminUser(user);
}
